<div class="label-container">
  <p class="label-text" [ngClass]="{ disabled: disabled }">{{ label | translate }}</p>
</div>
